import { useMutation } from '@tanstack/react-query'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

export const confirmShipment = (token, orderNumber) => {
    return requestBusinessObjects({
        method: 'PATCH',
        url: `order/${orderNumber}/shipment-confirmation`,
        data: { shipmentConfirmationStatus: 'CONFIRMED' },
        token,
    })
        .then((result) => {
            return result.data
        })
}

function useConfirmShipment() {
    const token = useJWTToken()

    return useMutation({ mutationFn: ({ orderNumber }) => {
        return confirmShipment(token, orderNumber)
    } })
}

export default useConfirmShipment
